import { Component, h, Host } from '@stencil/core';
import state from '@ugc-store';
import { IncentiveBanner } from '../../icons';

@Component({
  tag: 'ugc-review-banner',
  styleUrl: 'ugc-review-banner.scss',
  shadow: false,
})
export class UgcReviewBanner {
  render() {
    const {
      reviewStaticLanguage: {
        IDS_UGCI_PROMO_BANNER_V2 = '',
        IDS_UGCI_PROMO_BANNER_TITLE_V2 = '',
        IDS_UGC_LEARN_MORE = '',
      } = {},
      ids,
      isDesktop,
      isShowReviewSkeleton,
    } = state;
    if (isShowReviewSkeleton) return null;
    if (!ids.length && isDesktop) return null;
    return (
      <Host>
        <div class="incentive-banner-wrap">
          <div class="icon-wrapper">
            <IncentiveBanner />
          </div>
          <div class="flex-col-start-start">
            <h6
              class="fs-16 lh-24 m-0"
              tabIndex={0}
              role="text"
              style={{ cursor: 'pointer' }}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                }
              }}
            >
              {IDS_UGCI_PROMO_BANNER_TITLE_V2}
            </h6>
            <span class="fs-16 lh-24">{IDS_UGCI_PROMO_BANNER_V2}</span>

            <a
              href="#"
              class="fs-16 lh-24 color-blue-dark"
              onClick={e => {
                e.preventDefault();
                state.isShowReviewLearnMoreModal = true;
              }}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  state.isShowReviewLearnMoreModal = true;
                }
              }}
              tabIndex={0}
              role="button"
              aria-label={`${IDS_UGC_LEARN_MORE}: Open guidelines modal`}
            >
              {IDS_UGC_LEARN_MORE}
            </a>
          </div>
        </div>
      </Host>
    );
  }
}
